import {createStore} from "ui.vue3.vuex"
import {BitrixVue} from "ui.vue3"
import {Form} from "./form"

export class Basket {
    constructor(rootNode, data, siteId, siteTemplateId, ajaxPath, signedTemplate, signedParameters) {
        this.rootNode = document.getElementById(rootNode)

        this.data = data
        this.siteId = siteId
        this.siteTemplateId = siteTemplateId
        this.ajaxPath = ajaxPath
        this.signedTemplate = signedTemplate
        this.signedParameters = signedParameters
    }

    init() {
        let context = this,
            store = createStore({
                state() {
                    return {...context.data, loading: false}
                },
                mutations: {
                    setCoupon(state, value) {
                        state.coupon = value
                    },
                    setItems(state, items) {
                        state.items = items
                    },
                    setTotal(state, value) {
                        state.total = value
                    },
                    setCoupons(state, coupons) {
                        state.coupons = coupons
                    }
                },
                actions: {
                    sendCoupon(store) {
                        let data = {'basket[coupon]': store.state.coupon}
                        store.dispatch('sendRequest', data)
                    },
                    deleteCoupon(store, coupon) {
                        let data = {'basket[delete_coupon]': coupon}

                        store.dispatch('sendRequest', data)
                    },
                    toggleItems(store, checked) {
                        store.commit('setItems', store.state.items.map(item => {
                            return {...item, 'CHECKED': checked}
                        }))

                        let data = {}
                        for (let item of store.state.items) {
                            let key = 'basket[DELAY_' + item.ID + ']'

                            data[key] = checked ? 'N' : 'Y'
                        }

                        store.dispatch('sendRequest', data)
                    },
                    deleteItems(store) {
                        let data = {}

                        for (let item of store.state.items) {
                            let key = 'basket[DELETE_' + item.ID + ']'

                            data[key] = 'Y'
                        }

                        store.dispatch('sendRequest', data)
                    },
                    deleteCheckedItems(store) {
                        let data = {}

                        for (let item of store.state.items) {
                            let key = 'basket[DELETE_' + item.ID + ']'

                            if (item.CHECKED)
                                data[key] = 'Y'
                        }

                        store.dispatch('sendRequest', data)
                    },
                    sendRequest(store, data) {
                        data = data || {}

                        data.basketAction = 'recalculateAjax';
                        data.via_ajax = 'Y';
                        data.site_id = context.siteId;
                        data.site_template_id = context.siteTemplateId;
                        data.sessid = BX.bitrix_sessid();
                        data.template = context.signedTemplate;
                        data.signedParamsString = context.signedParameters;

                        BX.ajax({
                            method: 'POST',
                            dataType: 'json',
                            url: context.ajaxPath,
                            data: data,
                            onsuccess: function (result) {
                                console.log(result)
                                let basketData = result.BASKET_DATA

                                if (basketData.EMPTY_BASKET) {
                                    location.reload()
                                } else {
                                    store.commit('setItems', basketData.BASKET_ITEM_RENDER_DATA)
                                    store.commit('setTotal', basketData.TOTAL_RENDER_DATA)
                                    store.commit('setCoupons', basketData.COUPON_LIST)
                                    store.commit('setCoupon', '')
                                    store.commit('setAuthorized', basketData.AUTHORIZED)
                                }
                            },
                            onfailure: function (result) {
                                console.log(result)
                            }
                        })
                    }
                }
            }),
            application = BitrixVue.createApp({
                name: 'Basket',
                components: {Form},
                beforeCreate() {
                    this.$bitrix.Application.set(context);
                },
                template: `<Form />`
            })

        application.use(store)
        application.mount(this.rootNode)
    }
}
